"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateCreateContract = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const createContractMutation = (0, graphql_tag_1.default) `
  mutation RoleContractCreate($workspaceId: ID!, $userId: ID!, $data: RoleContractInput!) {
  roleContractCreate(workspace: $workspaceId, user: $userId, data: $data) {
    type
    positions {
      skill
      productionForecast
      positionId
      created
    }
    period {
      end
      start
    }
    options
    id
    default
    contractId
  }
}
  `;
const mutateCreateContract = async (variables) => {
    const { data, errors } = await (0, apollo_1.mutate)(createContractMutation, { variables });
    (0, error_handler_1.processErrors)(errors);
    return data?.roleContractCreate;
};
exports.mutateCreateContract = mutateCreateContract;
